import { css } from "@emotion/react";

export const styles = {
  singleLine: css`
    position: relative;
    display: flex;
    overflow: hidden;
    white-space: nowrap;
  `,
  multiLine: css`
    position: relative;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: var(--truncate-lines, 1);
  `,
  tooltip: css`
    position: absolute;
    inset: 0;

    > .bp4-popover-wrapper,
    > .bp4-popover-wrapper > span {
      position: absolute;
      inset: 0;
    }
  `,
  overflowIndicator: css`
    display: inline-block;
    line-height: 1;
  `,
  offsetBase: css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  suffixWithOverflow: css`
    transform: translateX(-0.5ch); // remove whitespace after ellipsis
  `
};
